import { BiTableView } from '@euler/app/components/message/widgets/bi-visualization/BiTableView';
import {
  CardLoading,
  CardNotice,
} from '@euler/app/flows/ai-suite/components/ChatCard';
import { BiVizType } from '@euler/model/bi/viz';
import { memo, useMemo } from 'react';
import { BiRetry } from '../../components/ui/BiRetry';
import { DetailSection } from './DetailSection';
import { BiDatasetPreviewState } from './functions/useBiDatasetDetail';

/** The dataset's first rows, as stored. */
export const PreviewSection = memo(
  ({
    state,
    rowCount,
    onRetry,
  }: {
    state: BiDatasetPreviewState;
    rowCount: number;
    onRetry: () => void;
  }) => {
    const viz = useMemo(
      () =>
        state.kind === 'ready'
          ? {
              type: BiVizType.Table as const,
              columns: state.preview.columns.map(column => ({
                key: column.key,
              })),
            }
          : null,
      [state],
    );
    return (
      <DetailSection
        title={
          state.kind === 'ready'
            ? `数据预览（前 ${
                state.preview.rows.length
              } 行，共 ${rowCount.toLocaleString('zh-CN')} 行）`
            : '数据预览'
        }
      >
        {state.kind === 'loading' ? (
          <CardLoading label="正在读取数据…" />
        ) : state.kind === 'failed' ? (
          <>
            <CardNotice tone="danger" text="预览没有加载出来。" />
            <BiRetry onRetry={onRetry} />
          </>
        ) : !state.preview.rows.length || !viz ? (
          <CardNotice text="这份数据没有行。" />
        ) : (
          <BiTableView viz={viz} result={state.preview} />
        )}
      </DetailSection>
    );
  },
);
